import {Box, Typography} from '@mui/material';

export default function NavBarMobileMenuDrawerMenuHeader() {
  return (
    <Box data-testid="navbar-mobile-menu-drawer-menu-header" sx={{mb: 4, textAlign: 'center'}}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          color: 'primary.main',
          mb: 1,
        }}
      >
        Menu
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
        }}
      >
        Navigate to different sections
      </Typography>
    </Box>
  );
}
